import Button from './Button'
import Input from './Input'
import PasswordInput from './PasswordInput'
import Table from './Table'
import Textarea from './TextArea'
import TextInput from './TextInput'

export default {
  ...Input,
  ...TextInput,
  ...PasswordInput,
  ...Button,
  ...Textarea,
  ...Table,
}
